document.addEventListener('DOMContentLoaded', () => {
  const content = document.getElementById('seoTextContent');
  const toggle = document.getElementById('seoTextToggle');

  // If essential elements don't exist, do nothing.
  if (!content || !toggle) {
    return;
  }

  // Check if the content is actually overflowing.
  const isOverflowing = content.scrollHeight > content.clientHeight;

  if (isOverflowing) {
    toggle.classList.remove('is-hidden');
  } else {
    return;
  }

  // Attach the click event listener to the button.
  toggle.addEventListener('click', () => {
    const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

    toggle.setAttribute('aria-expanded', !isExpanded);

    // Update the button text.
    toggle.textContent = isExpanded ? 'Devamını Oku' : 'Devamını Gizle';

    if (isExpanded) {
      // Collapse
      content.style.maxHeight = null;
      content.classList.remove('is-expanded');
    } else {
      content.style.maxHeight = `${content.scrollHeight}px`;
      content.classList.add('is-expanded');
    }
  });
});